window.Modal = class Modal {
    constructor(modalId) {
        this.modal = document.getElementById(modalId);
        if (!this.modal) return;
        this.dialog = this.modal.querySelector('.modal__dialog');
        this.closers = this.modal.querySelectorAll('.modal__close');
        this.backdrop = null;
        this.init();
    }

    open() {
        if (!this.modal) return;
        this.createBackdrop();
        this.modal.classList.add('modal--active');
        document.body.classList.add('modal--open');
        this.dialog.focus?.();
        document.addEventListener('keydown', this._escHandler);
    }

    close() {
        if (!this.modal) return;
        this.modal.classList.remove('modal--active');
        document.body.classList.remove('modal--open');
        if (this.backdrop) this.backdrop.classList.remove('modal__backdrop--active');
        document.removeEventListener('keydown', this._escHandler);
    }

    createBackdrop() {
        if (!this.backdrop) {
            this.backdrop = document.createElement('div');
            this.backdrop.className = 'modal__backdrop modal__backdrop--active';
            document.body.appendChild(this.backdrop);
            this.backdrop.addEventListener('click', () => this.close());
        } else {
            this.backdrop.classList.add('modal__backdrop--active');
        }
    }

    _escHandler = (e) => { if (e.key === 'Escape') this.close(); }

    init() {
        const triggers = document.querySelectorAll(`[data-modal-target="#${this.modal.id}"]`);
        triggers.forEach(trigger => trigger.addEventListener('click', e => {
            e.preventDefault();
            this.open();
        }));

        this.closers.forEach(btn => btn.addEventListener('click', () => this.close()));
    }
}

/*
<div id="meuModal" class="modal" tabindex="-1" role="dialog">
  <div class="modal__dialog" role="document">
    <button type="button" class="modal__close" aria-label="Fechar">&times;</button>
    <div class="modal__body">
      <p>Este é o conteúdo principal do modal.</p>
    </div>
    <div class="modal__footer">
      <button type="button" class="modal__close">Fechar</button>
    </div>
  </div>
</div>
<a href="#" data-modal-target="#meuModal">Abrir Modal</a>
*/
